import { DragEndEvent } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import { AgentDetails } from '@urbanx/agx.agencies.client';
import { AgxSortableList } from '@urbanx/agx-ui-components';
import { AgxAvatarLabelGroup, AgxSpacer } from '@urbanx/agx.ui-components2';
import { useCallback } from 'react';

const SortableTeamMembers = ({
  orderedMembersList,
  agencyMembers,
  orderUpdated,
}: {
  orderedMembersList: string[];
  agencyMembers: AgentDetails[];
  orderUpdated: (newOrder: string[]) => void;
}) => {
  const renderItem = (memberId: string) => {
    const member = agencyMembers.find((agent) => agent.id === memberId);
    if (!member) return null;
    return (
      <AgxSpacer padding={{ top: 'spacing-xl', bottom: 'spacing-xl' }} fill>
        {/* Start alignment stops the legacy `.horizontal` width rule from centring the group. */}
        <AgxSpacer contentAlignment="start">
          <AgxAvatarLabelGroup
            id={`team-member-${member.id}`}
            imageUrl={member.photo?.publicPath}
            label1={`${member.firstName} ${member.lastName}`}
            mode="letters"
            backgroundMode="dark"
            size="sm"
          />
        </AgxSpacer>
      </AgxSpacer>
    );
  };

  const handleOnDragEnd = useCallback(
    (event: DragEndEvent) => {
      const { active, over } = event;

      if (active?.id === over?.id) return;

      if (!orderedMembersList || orderedMembersList?.length === 0) return;

      const oldIndex = orderedMembersList?.indexOf(active.id.toString());
      const newIndex = orderedMembersList?.indexOf(over?.id.toString() ?? '') || 0;

      if (oldIndex === newIndex) return;

      const updatedOrderItems = arrayMove(orderedMembersList!, oldIndex!, newIndex);

      orderUpdated(updatedOrderItems);
    },
    [orderedMembersList, orderUpdated]
  );

  return (
    <AgxSortableList
      items={orderedMembersList ?? []}
      getId={(memberId) => (memberId ? memberId : 'addTeam')}
      renderItem={(memberId) => renderItem(memberId)}
      onDragEnd={handleOnDragEnd}
    />
  );
};

export default SortableTeamMembers;
